import { SegmentationType, TransactionType } from '../../../@types/types'
import type { PersistedSegmentationState } from '../../../redux/reducers/segmentation/segmentationFeature'

// currently we only open support for marketing landing page for sale, but this can be extended in future https://www.immobilienscout24.de/anbieten/private-anbieter/lp/verkaufen-lp-version-a.html
export const parseSegmentationPreselection = (search: string): PersistedSegmentationState | undefined => {
  const params = new URLSearchParams(search)
  if (
    params.getAll('rolle').length !== 1 ||
    params.getAll('vorhaben').length !== 1 ||
    params.get('rolle') !== 'eigentuemer' ||
    params.get('vorhaben') !== 'verkaufen'
  ) {
    return undefined
  }

  return {
    selectedIdentity: SegmentationType.PROPERTY_OWNER,
    selectedIntent: TransactionType.SELL,
    selectedPropertyTypes: [],
    isShortTermAccommodation: false,
    showBusinessCategories: false,
  }
}
